export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvMenu.vue?vue&type=template&id=5ed54dcc&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvMenu.vue?vue&type=template&id=5ed54dcc&lang=pug&
// module id = 124
// module chunks = 0 1